export const transformToISO = (date) => {
  return [date.slice(4, 8), date.slice(0, 2), date.slice(2, 4)].join('-');
};

export const transformToDate = (dateInISOFormat) => {
  return [dateInISOFormat.slice(5, 7), dateInISOFormat.slice(8, 10), dateInISOFormat.slice(0, 4)].join('');
};
